import React from "react";

import destination_1 from "../../public/wheretogo-krkonose/spindleruvmlyn/destination_1.png";
import destination_2 from "../../public/wheretogo-krkonose/spindleruvmlyn/destination_2.png";
import destination_3 from "../../public/wheretogo-krkonose/spindleruvmlyn/destination_3.png";
import destination_4 from "../../public/wheretogo-krkonose/spindleruvmlyn/destination_4.png";
import destination_5 from "../../public/wheretogo-krkonose/spindleruvmlyn/destination_5.png";

import destinationIcon_1 from "../../public/wheretogo-krkonose/spindleruvmlyn/icon_1.png";
import destinationIcon_2 from "../../public/wheretogo-krkonose/spindleruvmlyn/icon_2.png";
import destinationIcon_3 from "../../public/wheretogo-krkonose/spindleruvmlyn/icon_3.png";
import destinationIcon_4 from "../../public/wheretogo-krkonose/spindleruvmlyn/icon_4.png";

import { useContext } from "react";
import { DarkModeContext } from "../../components/DarkModeProvider";

const SpindleruvMlyn = () => {
  const { darkMode } = useContext(DarkModeContext);

  return (
    <>
      <section className={`destinations ${darkMode ? "dark" : "light"}`}>
        <div className="container">
          <div className="destinations__container">
            <img src={destination_1} alt="" />
            <h1>Špindlerův Mlýn</h1>
            <p>
              Špindlerovu Mlýnu dnes neodmyslitelně patří bílý železobetonový
              obloukový most přes Labe, pěší zóna v centru města, kostel sv.
              Petra a Pavla, řada hotelů, chalup a penzionů a především
              nepřeberné množství aktivit, které horské středisko na jižní
              straně Krkonoš nabízí.
            </p>
          </div>
        </div>
      </section>

      <section className={`destinations__icons ${darkMode ? "dark" : "light"}`}>
        <div className="container">
          <div className="destinations__icons--container">
            <div className="destinations__icon">
              <img src={destinationIcon_1} alt="" />
              <p>ubytování</p>
            </div>
            <div className="destinations__icon">
              <img src={destinationIcon_2} alt="" />
              <p>wellness</p>
            </div>
            <div className="destinations__icon">
              <img src={destinationIcon_3} alt="" />
              <p>lyžařské sjezdovky</p>
            </div>
            <div className="destinations__icon">
              <img src={destinationIcon_4} alt="" />
              <p>dostupnost</p>
            </div>
          </div>
        </div>
      </section>

      <section
        className={`destinations__attractions ${darkMode ? "dark" : "light"}`}
      >
        <div className="container">
          <div className="destinations__attractions--container">
            <div className="destinations__attractions--image">
              <img className="destination_1" src={destination_2} alt="" />
              <img className="destination_2" src={destination_3} alt="" />
              <img className="destination_3" src={destination_4} alt="" />
              <img className="destination_4" src={destination_5} alt="" />
            </div>
            <div className="destinations__attractions--content">
              <h2>Zajímavosti</h2>
              <ul>
                <li>
                  Město se řadí k nejznámějším a nejnavštěvovanějším střediskům
                  zimních sportů v České republice.Lyžařské a běžecké tratě jsou
                  v provozu až 5 měsíců v roce. Profesionálně upravované
                  sjezdové tratě různého stupně obtížnosti dosahují celkové
                  délky 25 km
                </li>
                <li>
                  Symbolem města se stal Bílý most vedoucí přes řeku Labe. Jedná
                  se o 27,6 m dlouhý a 4,84 m široký most ze železobetonu
                </li>
                <li>
                  První sedačková lanovka zde byla zprovozněna v roce 1947,
                  vedla ze Svatého Petra na Pláň. K roku 2016 zde bylo celkem 43
                  hotelů, 134 penzionů a 23 horských boud
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default SpindleruvMlyn;
